import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class GameOverScreen extends Phaser.Scene {

  preload() {
    const font = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(font);
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    const gameOver = this.add.text( width / 2, height / 2, "Game Over", {
        fontFamily: "'Press Start 2P'",
        fontSize: 40,
        color: "#f38ba8"
    });

    this.input.keyboard.once("keydown-SPACE", () => {
      this.scene.start('game')
    });
    gameOver.setOrigin(0.5, 0.5);

    const tellSPACE = this.add.text(width / 1.5, height / 1.7, "Press SPACE To Restart", {
      fontFamily: "'Press Start 2P'",
      fontSize: 13,
      color: "#cdd6f4"
    });
    tellSPACE.setOrigin(0.5);
  }


}
